import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../apiConfig';

const defaultStaffList = [
    {
        id: 1,
        position: 'පළාත් කෘෂිකර්ම අධ්‍යක්ෂ',
        name: 'ජී.බී.ඒ.ඩී. රාජපක්ෂ මිය',
        phone: '071-8061972',
        image: '/photos/staff1.jpg'
    },
    {
        id: 2,
        position: 'අතිරේක පළාත් කෘෂිකර්ම අධ්‍යක්ෂ',
        name: 'ආර්.පී.එන්.එල්. රාජපක්ෂ මිය',
        phone: '074-1248180',
        image: '/photos/staff2.png'
    },
    {
        id: 3,
        position: 'සහකාර කෘෂිකර්ම අධ්‍යක්ෂ(මූලස්ථාන)',
        name: 'ඩබ්.එම්.එස්.එන්. වනසුන්දර මයා',
        phone: '071-8179452',
        image: '/photos/staff3.jpg'
    },
    {
        id: 4,
        position: 'ගණකාධිකාරි',
        name: 'අයෝමි විදානගමගේ මිය',
        phone: '071-0361089',
        image: '/photos/staff4.png'
    },
    {
        id: 5,
        position: 'පරිපාලන නිලධාරි',
        name: 'ආර්.ආර්. රෝෂාණී මිය',
        phone: '070-5577568',
        image: '/photos/staff5.jpg'
    },
    {
        id: 6,
        position: 'විෂයභාර නිලධාරි(මූලස්ථාන)',
        name: 'එම්.පී. මුණසිංහ මයා',
        phone: '077-7930584',
        image: '/photos/staff6.png'
    },
    {
        id: 7,
        position: 'පළාත් මාධ්‍ය සම්බන්ධීකාරක',
        name: 'දිල්හානි වික්‍රමසිංහ මිය',
        phone: '077-6063540',
        image: '/photos/staff7.jpg'
    },
    {
        id: 8,
        position: 'ප්‍රධාන කලමණාකරණසේවා නිලධාරි',
        name: 'විමලා විජේමැණිකේ මිය',
        phone: '071-7645314',
        image: '/photos/staff8.png'
    },
    {
        id: 9,
        position: 'මුදල් සහකාර',
        name: 'පවිත්‍රා සේල්ලහේවා මිය',
        phone: '077-2258582',
        image: '/photos/staff9.png'
    }
];

export default function StaffManager() {
    const [staff, setStaff] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({ name: '', position: '', phone: '', image: '' });
    const [editing, setEditing] = useState(null);
    const [message, setMessage] = useState('');
    const [imagePreview, setImagePreview] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchStaff = async () => {
            setLoading(true);
            try {
                const res = await fetch(getApiUrl(`api_staff.php?t=${Date.now()}`));
                if (!res.ok) throw new Error('API server error');
                const data = await res.json();
                
                if (Array.isArray(data) && data.length > 0) {
                    setStaff(data);
                } else {
                    // Initialize with default staff if empty
                    setStaff(defaultStaffList);
                    // Sync default list so server creates the file
                    fetch(getApiUrl('api_staff.php'), {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(defaultStaffList)
                    }).catch(e => console.warn('Sync default staff error:', e));
                }
            } catch (err) {
                console.error('Failed to fetch staff:', err);
                const localStaff = localStorage.getItem('site_staff');
                if (localStaff) {
                    try {
                        const parsed = JSON.parse(localStaff);
                        setStaff(Array.isArray(parsed) && parsed.length > 0 ? parsed : defaultStaffList);
                    } catch (e) {
                        setStaff(defaultStaffList);
                    }
                } else {
                    setStaff(defaultStaffList);
                }
                setMessage('⚠ සර්වර් එක සමඟ සම්බන්ධ වීමට නොහැකි විය. Local දත්ත පෙන්වයි.');
            } finally {
                setLoading(false);
            }
        };
        fetchStaff();
    }, []);

    const handleEditClick = (item) => {
        setEditing(item.id);
        setForm({
            name: item.name || '',
            position: item.position || '',
            phone: item.phone || '',
            image: item.image || ''
        });
        setImagePreview(item.image || '');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleCancelEdit = () => {
        setEditing(null);
        setForm({ name: '', position: '', phone: '', image: '' });
        setImagePreview('');
        const fileInput = document.getElementById('staffImageUpload');
        if (fileInput) fileInput.value = '';
    };

    const handleSubmit = async (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        setMessage('');

        if (!form.name.trim() || !form.position.trim()) {
            setMessage('⚠ කරුණාකර නම සහ තනතුර ඇතුළත් කරන්න (Name & Position are required)');
            return;
        }

        try {
            const currentStaff = Array.isArray(staff) ? [...staff] : [];
            let updatedStaff;

            if (editing !== null) {
                // Update existing staff
                updatedStaff = currentStaff.map(item => {
                    if (String(item.id) === String(editing)) {
                        return {
                            ...item,
                            name: form.name.trim(),
                            position: form.position.trim(),
                            phone: form.phone ? form.phone.trim() : '',
                            image: form.image || ''
                        };
                    }
                    return item;
                });
            } else {
                // Add new staff
                const newId = Date.now();
                const newItem = {
                    id: newId,
                    name: form.name.trim(),
                    position: form.position.trim(),
                    phone: form.phone ? form.phone.trim() : '',
                    image: form.image || ''
                };
                updatedStaff = [...currentStaff, newItem];
            }

            setStaff(updatedStaff);

            try {
                localStorage.setItem('site_staff', JSON.stringify(updatedStaff));
            } catch (err) {
                console.warn('Local storage backup failed', err);
            }

            try {
                const response = await fetch(getApiUrl('api_staff.php'), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(updatedStaff)
                });

                if (response.ok) {
                    setMessage(editing !== null ? '✅ නිලධාරියාගේ තොරතුරු සාර්ථකව යාවත්කාලීන විය! (Updated)' : '✅ නව නිලධාරියා සාර්ථකව ඇතුළත් කර Save කරන ලදී! (Added)');
                } else {
                    throw new Error('Sync failed');
                }
            } catch (apiErr) {
                console.error('Server sync failed:', apiErr);
                setMessage('⚠ Local දත්ත සුරැකිණි, නමුත් සර්වර් එකට Save වීමේ දෝෂයක් ඇත. (Check Apache/File Permissions)');
            }

            handleCancelEdit();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => setMessage(''), 5000);

        } catch (err) {
            console.error('Critical submit error:', err);
            setMessage('⚠ Error: ' + err.message);
        }
    };

    const handleDelete = async (id) => {
        const itemToDelete = staff.find(n => String(n.id) === String(id));
        const staffName = itemToDelete ? itemToDelete.name : 'මෙම නිලධාරියා';

        if (window.confirm(`"${staffName}" කාර්ය මණ්ඩලයෙන් ඉවත් කිරීමට ඔබට සහතිකද?`)) {
            const updatedStaff = staff.filter(n => String(n.id) !== String(id));
            setStaff(updatedStaff);

            if (editing !== null && String(editing) === String(id)) {
                handleCancelEdit();
            }

            try {
                localStorage.setItem('site_staff', JSON.stringify(updatedStaff));
                await fetch(getApiUrl('api_staff.php'), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(updatedStaff)
                });
                setMessage('✅ කාර්ය මණ්ඩල සාමාජිකයා සාර්ථකව ඉවත් කරන ලදී! (Deleted)');
                setTimeout(() => setMessage(''), 4000);
            } catch (e) {
                console.error('API Save Error:', e);
                setMessage('⚠ ඉවත් කිරීම සර්වර් එකේ Save නොවීය.');
            }
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 2 * 1024 * 1024) {
                setMessage('⚠ Image size should be less than 2MB');
                return;
            }
            if (!file.type.startsWith('image/')) {
                setMessage('⚠ Please select a valid image file');
                return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setForm(prev => ({ ...prev, image: base64String }));
                setImagePreview(base64String);
            };
            reader.readAsDataURL(file);
        }
    };

    const removeImage = () => {
        setForm(prev => ({ ...prev, image: '' }));
        setImagePreview('');
        const fileInput = document.getElementById('staffImageUpload');
        if (fileInput) fileInput.value = '';
    };

    const filteredStaff = staff.filter(item => {
        if (!searchTerm.trim()) return true;
        const q = searchTerm.toLowerCase();
        return (
            (item.name && item.name.toLowerCase().includes(q)) ||
            (item.position && item.position.toLowerCase().includes(q)) ||
            (item.phone && item.phone.toLowerCase().includes(q))
        );
    });

    return (
        <div className="manager-container">
            <div className="admin-grid">
                {/* FORM SECTION */}
                <div className="form-section">
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '15px',
                        borderBottom: '2px solid #e2e8f0',
                        paddingBottom: '10px'
                    }}>
                        <h3 style={{ margin: 0, color: '#166534', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {editing !== null ? '✏️ Edit Staff (තොරතුරු සංස්කරණය)' : '➕ Add Staff (නව නිලධාරියෙකු ඇතුළත් කිරීම)'}
                        </h3>
                        {editing !== null && (
                            <span style={{
                                background: '#fef08a',
                                color: '#854d0e',
                                padding: '4px 10px',
                                borderRadius: '12px',
                                fontSize: '0.82rem',
                                fontWeight: 'bold'
                            }}>
                                සංස්කරණ මාදිලිය
                            </span>
                        )}
                    </div>

                    {message && (
                        <div style={{
                            padding: '12px',
                            background: message.startsWith('✅') ? '#dcfce7' : '#fee2e2',
                            color: message.startsWith('✅') ? '#15803d' : '#b91c1c',
                            borderRadius: '8px',
                            marginBottom: '15px',
                            textAlign: 'center',
                            fontWeight: '600',
                            border: message.startsWith('✅') ? '1px solid #bbf7d0' : '1px solid #fecaca'
                        }}>
                            {message}
                        </div>
                    )}

                    <div className="publish-form-wrapper">
                        <div className="form-group">
                            <label style={{ fontWeight: '600', color: '#334155' }}>
                                Name (නම) <span style={{ color: '#dc2626' }}>*</span>
                            </label>
                            <input
                                type="text"
                                value={form.name}
                                onChange={(e) => setForm({ ...form, name: e.target.value })}
                                placeholder="උදා: ජී.බී.ඒ.ඩී. රාජපක්ෂ මිය..."
                                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                            />
                        </div>

                        <div className="form-group">
                            <label style={{ fontWeight: '600', color: '#334155' }}>
                                Position (තනතුර) <span style={{ color: '#dc2626' }}>*</span>
                            </label>
                            <input
                                type="text"
                                value={form.position}
                                onChange={(e) => setForm({ ...form, position: e.target.value })}
                                placeholder="උදා: පළාත් කෘෂිකර්ම අධ්‍යක්ෂ..."
                                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                            />
                        </div>

                        <div className="form-group">
                            <label style={{ fontWeight: '600', color: '#334155' }}>
                                Phone (දුරකථන අංකය)
                            </label>
                            <input
                                type="text"
                                value={form.phone}
                                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                                placeholder="උදා: 071-8061972..."
                                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                            />
                        </div>

                        <div className="form-group">
                            <label style={{ fontWeight: '600', color: '#334155' }}>Photo (ඡායාරූපය)</label>
                            <div style={{ marginBottom: '10px' }}>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    style={{ display: 'none' }}
                                    id="staffImageUpload"
                                />
                                <label
                                    htmlFor="staffImageUpload"
                                    style={{
                                        display: 'inline-block',
                                        padding: '9px 18px',
                                        background: '#15803d',
                                        color: '#fff',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        fontWeight: '600',
                                        transition: 'background 0.2s',
                                        fontSize: '0.9rem'
                                    }}
                                    onMouseOver={(e) => e.target.style.background = '#166534'}
                                    onMouseOut={(e) => e.target.style.background = '#15803d'}
                                >
                                    📷 {editing && form.image ? 'ඡායාරූපය වෙනස් කරන්න (Change Photo)' : 'ඡායාරූපයක් තෝරන්න (Choose Photo)'}
                                </label>
                                {(imagePreview || form.image) && (
                                    <button
                                        type="button"
                                        onClick={removeImage}
                                        style={{
                                            marginLeft: '10px',
                                            padding: '9px 16px',
                                            background: '#ef4444',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            fontWeight: '600',
                                            fontSize: '0.9rem'
                                        }}
                                    >
                                        ✕ ඉවත් කරන්න (Remove)
                                    </button>
                                )}
                            </div>

                            {(imagePreview || form.image) && (
                                <div style={{
                                    marginTop: '10px',
                                    display: 'inline-block',
                                    padding: '5px',
                                    background: '#f8fafc',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <img
                                        src={imagePreview || form.image}
                                        alt="Preview"
                                        style={{
                                            width: '120px',
                                            height: '140px',
                                            objectFit: 'cover',
                                            borderRadius: '6px',
                                            border: '1px solid #cbd5e1',
                                            display: 'block'
                                        }}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                            <button
                                type="button"
                                className="login-btn"
                                onClick={(e) => handleSubmit(e)}
                                disabled={!form.name || !form.position}
                                style={{
                                    flex: '1',
                                    padding: '12px 20px',
                                    fontSize: '1rem',
                                    fontWeight: '600',
                                    background: editing !== null ? '#0284c7' : '#15803d',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: (!form.name || !form.position) ? 'not-allowed' : 'pointer',
                                    opacity: (!form.name || !form.position) ? 0.6 : 1
                                }}
                            >
                                {editing !== null ? '💾 Update Staff (යාවත්කාලීන කරන්න)' : '➕ Add Staff (ඇතුළත් කරන්න)'}
                            </button>

                            {editing !== null && (
                                <button
                                    type="button"
                                    onClick={handleCancelEdit}
                                    style={{
                                        padding: '12px 20px',
                                        background: '#64748b',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        fontWeight: '600'
                                    }}
                                >
                                    ✕ Cancel (අවලංගු කරන්න)
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* LIST SECTION */}
                <div className="list-section">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '10px',
                        marginBottom: '15px'
                    }}>
                        <h3 style={{ margin: 0, color: '#1e293b' }}>
                            Current Staff (කාර්ය මණ්ඩලය: {staff.length})
                        </h3>
                        <input
                            type="text"
                            placeholder="🔍 නම හෝ තනතුර අනුව සොයන්න..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                padding: '8px 14px',
                                border: '1px solid #cbd5e1',
                                borderRadius: '6px',
                                fontSize: '0.88rem',
                                minWidth: '220px'
                            }}
                        />
                    </div>

                    {loading ? (
                        <p style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>Loading staff data...</p>
                    ) : (
                        <div className="news-list" style={{ maxHeight: '650px', overflowY: 'auto' }}>
                            {filteredStaff.length === 0 ? (
                                <p style={{ textAlign: 'center', color: '#888', padding: '20px' }}>
                                    {searchTerm ? 'සෙවුමට අදාළ නිලධාරීන් හමු නොවීය.' : 'කාර්ය මණ්ඩල සාමාජිකයන් කිසිවක් නැත.'}
                                </p>
                            ) : (
                                filteredStaff.map((item, index) => {
                                    const isBeingEdited = editing !== null && String(editing) === String(item.id);
                                    return (
                                        <div
                                            key={item.id || index}
                                            style={{
                                                padding: '14px',
                                                borderBottom: '1px solid #e2e8f0',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                flexWrap: 'wrap',
                                                gap: '12px',
                                                background: isBeingEdited ? '#eff6ff' : 'transparent',
                                                borderLeft: isBeingEdited ? '4px solid #0284c7' : 'none',
                                                transition: 'background 0.2s'
                                            }}
                                        >
                                            <div style={{ display: 'flex', gap: '14px', flex: '1', minWidth: '260px', alignItems: 'center' }}>
                                                {item.image ? (
                                                    <img
                                                        src={item.image}
                                                        alt={item.name}
                                                        style={{
                                                            width: '60px',
                                                            height: '65px',
                                                            objectFit: 'cover',
                                                            borderRadius: '6px',
                                                            border: '1px solid #cbd5e1'
                                                        }}
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                            e.target.nextSibling.style.display = 'flex';
                                                        }}
                                                    />
                                                ) : null}
                                                <div
                                                    style={{
                                                        width: '60px',
                                                        height: '65px',
                                                        background: '#e2e8f0',
                                                        color: '#475569',
                                                        borderRadius: '6px',
                                                        display: item.image ? 'none' : 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontWeight: 'bold',
                                                        fontSize: '1.2rem'
                                                    }}
                                                >
                                                    {item.name ? item.name.charAt(0) : '👤'}
                                                </div>

                                                <div>
                                                    <h4 style={{ margin: '0 0 4px 0', color: '#0f172a', fontSize: '1rem' }}>
                                                        {item.name}
                                                    </h4>
                                                    <p style={{ margin: '0 0 4px 0', fontSize: '0.88rem', color: '#15803d', fontWeight: '600' }}>
                                                        {item.position}
                                                    </p>
                                                    <small style={{ color: '#64748b', fontSize: '0.84rem' }}>
                                                        📞 {item.phone || 'දුරකථන අංකයක් නැත'}
                                                    </small>
                                                </div>
                                            </div>

                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                <button
                                                    type="button"
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '8px 16px',
                                                        background: isBeingEdited ? '#0284c7' : '#f1f5f9',
                                                        color: isBeingEdited ? '#fff' : '#0f172a',
                                                        border: '1px solid #cbd5e1',
                                                        borderRadius: '6px',
                                                        fontWeight: '600',
                                                        fontSize: '0.88rem',
                                                        transition: 'all 0.2s'
                                                    }}
                                                    onClick={() => handleEditClick(item)}
                                                >
                                                    ✏️ {isBeingEdited ? 'Editing...' : 'Edit'}
                                                </button>
                                                <button
                                                    type="button"
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '8px 16px',
                                                        background: '#fee2e2',
                                                        color: '#b91c1c',
                                                        border: '1px solid #fecaca',
                                                        borderRadius: '6px',
                                                        fontWeight: '600',
                                                        fontSize: '0.88rem',
                                                        transition: 'all 0.2s'
                                                    }}
                                                    onClick={() => handleDelete(item.id)}
                                                >
                                                    🗑️ Delete
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
